import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="pt-20 pb-10 px-6 w-full mt-auto" style={{ background: '#061a12', borderTop: '1px solid rgba(255,255,255,0.07)' }}>
      <div className="max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
        <div className="col-span-1 md:col-span-2">
          <Link to="/" className="flex items-center mb-6 hover:opacity-80 transition">
            <img src="/assets/synex.png" alt="Synex Agency" className="h-9 w-auto" />
          </Link>
          <p className="text-sm leading-relaxed max-w-md" style={{ color: 'rgba(255,255,255,0.45)' }}>
            We architect intelligent AI systems and high-performing websites.
            Automate elite customer support, capture leads, and command a powerful digital presence.
          </p>
        </div>

        <div>
          <h4 className="font-semibold mb-6 text-[11px] font-mono uppercase tracking-widest" style={{ color: 'rgba(255,255,255,0.35)' }}>Platform</h4>
          <ul className="space-y-4">
            <li><Link to="/about" className="text-sm transition hover:text-white" style={{ color: 'rgba(255,255,255,0.5)' }}>About Us</Link></li>
            <li><Link to="/projects" className="text-sm transition hover:text-white" style={{ color: 'rgba(255,255,255,0.5)' }}>Work</Link></li>
            <li><Link to="/contact" className="text-sm transition hover:text-white" style={{ color: 'rgba(255,255,255,0.5)' }}>Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-semibold mb-6 text-[11px] font-mono uppercase tracking-widest" style={{ color: 'rgba(255,255,255,0.35)' }}>Connect</h4>
          <ul className="space-y-4">
            <li>
              <a href="mailto:hello@synex.agency" className="text-sm transition hover:text-white flex items-center gap-2" style={{ color: 'rgba(255,255,255,0.5)' }}>
                <span className="text-xs" style={{ color: '#d4f542' }}>✉</span>
                hello@synex.agency
              </a>
            </li>
            <li>
              <a href="#" className="text-sm transition hover:text-white flex items-center gap-2" style={{ color: 'rgba(255,255,255,0.5)' }}>
                <span className="text-xs" style={{ color: '#d4f542' }}>in</span>
                LinkedIn
              </a>
            </li>
            <li>
              <a href="#" className="text-sm transition hover:text-white flex items-center gap-2" style={{ color: 'rgba(255,255,255,0.5)' }}>
                <span className="text-xs" style={{ color: '#d4f542' }}>Dr</span>
                Dribbble
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div
        className="max-w-[1400px] mx-auto flex flex-col md:flex-row justify-between items-center text-xs font-mono uppercase tracking-widest pt-8"
        style={{ borderTop: '1px solid rgba(255,255,255,0.07)', color: 'rgba(255,255,255,0.28)' }}
      >
        <p>&copy; {new Date().getFullYear()} Synex Agency. All rights reserved.</p>
        <div className="flex gap-8 mt-4 md:mt-0">
          <a href="#" className="transition hover:text-white/60">Privacy</a>
          <a href="#" className="transition hover:text-white/60">Terms</a>
        </div>
      </div>
    </footer>
  );
}

